export const catchUndefinedProp = (obj: { [props: string]: any }) => {
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    if (typeof obj[keys[i]] === "undefined")
      throw new Error(keys[i] + " is undefined");
    if (typeof obj[keys[i]] === "object") {
      if (Array.isArray(obj[keys[i]])) {
        obj[keys[i]].forEach((O: any) => {
          if (typeof O === "object") {
            catchUndefinedProp(O);
          }
        });
      } else if (obj[keys[i]] === null) {
        continue;
      } else catchUndefinedProp(obj[keys[i]]);
    }
  }
};
